// Configuration constants
export const config = {
  // Environment variables are required
  BASE_DOMAIN: process.env.REACT_APP_BASE_DOMAIN!,
  API_BASE_URL: `${process.env.REACT_APP_BASE_DOMAIN!}/api`,
};

// Export individual constants for convenience
export const { BASE_DOMAIN, API_BASE_URL } = config;

// Validation helper
export const validateConfig = () => {
  if (!process.env.REACT_APP_BASE_DOMAIN) {
    throw new Error('REACT_APP_BASE_DOMAIN environment variable is required but not set. Please check your .env file.');
  }
};